import { render, staticRenderFns } from "./WikiDelete.vue?vue&type=template&id=2db95614&"
import script from "./WikiDelete.vue?vue&type=script&lang=js&"
export * from "./WikiDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports